var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "ConfirmMsgModal", "data-backdrop": "static" },
    },
    [
      _c("div", { staticClass: "modal-dialog confirm-modal-wrapper" }, [
        _c("div", { staticClass: "modal-content expiry-modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("div", { staticClass: "card text-center" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "card-title" }, [
                  _c("p", { staticClass: "first-card-title update-failed" }, [
                    _vm._v(_vm._s(_vm.confirmMessage)),
                  ]),
                ]),
                _vm._m(0),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-white-button",
                      on: {
                        click: function ($event) {
                          return _vm.closePopup(false)
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                ]),
                _c("div", { staticClass: "col-lg-6" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-blue-button",
                      on: {
                        click: function ($event) {
                          return _vm.closePopup(true)
                        },
                      },
                    },
                    [_vm._v("OK")]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-text" }, [
      _c("p", { staticClass: "confirm-message" }, [
        _vm._v("By discarding the changes will not save."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }